import React, { FC } from "react";
import { Link } from "react-router-dom";
import { ReactComponent as PreviewArrowSVG } from "go-core/images/svg/actions/preview-arrow.svg";
import { ReactComponent as AlertRedSVG } from "go-core/images/svg/alert.svg";
import { ReactComponent as AlertYellowSVG } from "go-core/images/svg/warning-alert.svg";
import useDashboardContext from "../../services/hooks/useDashboardContext";

interface Props {
	status: string;
	title: string;
	link: string | undefined;
	isModalItem: boolean;
}

const DashboardAlertItem: FC<Props> = ({ status, title, link, isModalItem }) => {
	const { isEditMode } = useDashboardContext();
	const drawAlertIcon = () => {
		if (status === "WARNING") return <AlertYellowSVG className="me-1 alert-svg" />;
		if (status === "DANGER") return <AlertRedSVG className="me-1 alert-svg" />;
	};

	return (
		<div className={`d-flex ${isModalItem ? "dashboard-alert-modal-item" : "dashboard-alert-item"}`}>
			{drawAlertIcon()}
			{link && !isEditMode ? (
				<Link to={link} title={title} rel="noreferrer noopener" target="_blank">
					{title}
				</Link>
			) : (
				<h5 className={`mb-0 lh-base ${isEditMode ? "text-muted" : ""}`} title={title}>
					{title}
				</h5>
			)}
			<PreviewArrowSVG className="text-end my-auto ms-1" />
		</div>
	);
};

export default DashboardAlertItem;
